// ABOUTME: Mock data for Rusada → TechLog defect deferral transformation path.
import type { RusadaToTechlogDefectDeferInput } from './validation';

export const mockData: RusadaToTechlogDefectDeferInput = {
  rusada: {
    melCategories: [
      {
        id: 1,
        melPriority: 'MEL A',
        description: 'MEL A',
        days: 1,
        noTargetDate: false,
      },
      {
        id: 2,
        melPriority: 'MEL B',
        description: 'MEL B',
        days: 3,
        noTargetDate: false,
      },
      {
        id: 3,
        melPriority: 'MEL C',
        description: 'MEL C',
        days: 10,
        noTargetDate: false,
      },
      {
        id: 4,
        melPriority: 'MEL D',
        description: 'MEL D',
        days: 120,
        noTargetDate: false,
      },
      {
        id: 5,
        melPriority: 'NO MEL',
        description: 'NO MEL',
        days: 1,
        noTargetDate: false,
      },
      {
        id: 6,
        melPriority: 'HUSB',
        description: 'Husbandry Log',
        days: 365,
        noTargetDate: false,
      },
    ],
    defect: {
      id: 456789,
      defectItemNo: 'DEF-2024-001',
      defect: 'Left engine oil pressure warning light illuminated during climb',
      regId: 42,
      reg: 'G-ZBKA',
      defectStatusId: 3, // 3 = Deferred
      defectStatus: 'Deferred',
      reportedByEmployeeId: 301,
      reportedByFirstName: 'John',
      reportedBySurname: 'Pilot',
      carriedOutByEmployeeId: 302,
      carriedOutByFirstName: 'Jane',
      carriedOutBySurname: 'Engineer',
      techLogId: 54321,
      techLogNo: 'TL-2024-001',
      flightId: 97081,
      flightNumber: 'BA456',
      ataChapterId: 79,
      ataChapter: '79-21',
      defectTypeId: 1,
      defectType: 'MAREP',
      defectCategoryId: 2,
      defectCategory: 'Defect',
      addReferenceId: 100,
      addReference: 'ADD-2024-001',
      melReference: 'MEL-79-21-01',
      melPriorityId: 3, // MEL C
      melPriority: 'MEL C',
      melCategory: 'MEL C',
      targetDate: '2024-01-30T23:59:59Z',
      defectSequenceNo: '2024001456',
      actionText:
        'Oil pressure sensor requires replacement. Part on order, expected 5 days.',
      openDate: '2024-01-20T11:30:00Z',
      closeDate: null,
      isReliability: true,
      remainingDays: 10,
      lastModifed: '2024-01-20T14:00:00Z',
    },
  },
  techlog: {
    defect: {
      id: 'TLD-2024-001456',
      aircraftId: 'TL-AC003',
      sectorId: 'TLS-2024-001234',
      reportAirportId: 1001,
      resolutionAirportId: null,
      details:
        'Left engine oil pressure warning light illuminated during climb. Engine parameters within normal limits.',
      itemDescription: 'Engine Oil Pressure Warning System',
      number: 2024001456,
      rectificationIntervalExtension: null,
      dueDate: null,
      dueDateTime: null,
      raisedAt: '2024-01-20T11:30:00Z',
      status: 'open',
      reference: 'DEF-BA-2024-001456',
      ataChapter: 79,
      ataSection: 21,
      limitations: null,
      melItemId: null,
      melRectificationId: null,
      placardProcedureCompleted: null,
      operationalProcedureCompleted: null,
      deferred: false,
      reportedById: 'TL-USER-PILOT-001',
      source: 'TECHLOG',
      createdAt: '2024-01-20T11:30:00Z',
      updatedAt: '2024-01-20T12:00:00Z',
    },
  },
  syncLog: {
    originEntityId: 'TLD-2024-001456',
    destinationEntityId: '456789',
  },
};
